<template>
  <div class="custom-slider">
    <input
      ref="slider"
      :value="String(value)"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      class="slider"
      @input="handleRangeChange"
    />
  </div>
</template>

<script>
export default {
  name: "BaseRange",
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 50,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        const progress = this.getProgress(value, this.min, this.max);
        this.setCSSProgress(progress);
      },
    },
  },
  methods: {
    getProgress(value, min, max) {
      return ((value - min) / (max - min)) * 100;
    },
    setCSSProgress(progress) {
      this.$refs.slider?.style?.setProperty(
        "--ProgressPercent",
        `${progress}%`
      );
    },
    handleRangeChange(event) {
      this.$emit("input", parseFloat(event.target.value));
    },
  },
};
</script>

<style scoped lang="less">
.custom-slider {
  --trackHeight: 0.5rem;
  --thumbRadius: 2rem;
  width: 100%;

  & input[type="range"] {
    -webkit-appearance: none;
    position: relative;
    -moz-appearance: none;
    appearance: none;
    border-radius: 999px;
    z-index: 0;
    cursor: pointer;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      cursor: pointer;
    }
  }

  & input[type="range"]::before {
    content: "";
    position: absolute;
    width: var(--ProgressPercent, 0%);
    height: 100%;
    background: @primary-color;
    pointer-events: none;
    border-radius: 999px;
    cursor: pointer;
  }

  & input[type="range"]::-webkit-slider-runnable-track {
    appearance: none;
    background: @link-color;
    height: var(--trackHeight);
    border-radius: 999px;
    cursor: pointer;
  }

  & input[type="range"]::-moz-range-track {
    appearance: none;
    background: @link-color;
    height: var(--trackHeight);
    border-radius: 999px;
    cursor: pointer;
  }

  & input[type="range"]::-webkit-slider-thumb {
    position: relative;
    width: var(--thumbRadius);
    height: var(--thumbRadius);
    margin-top: calc((var(--trackHeight) - var(--thumbRadius)) / 2);
    background: @primary-color;
    border-radius: 999px;
    pointer-events: all;
    appearance: none;
    z-index: 1;
    cursor: pointer;
  }

  & input[type="range"]::-moz-range-thumb {
    position: relative;
    width: var(--thumbRadius);
    height: var(--thumbRadius);
    margin-top: calc((var(--trackHeight) - var(--thumbRadius)) / 2);
    background: @primary-color;
    border-radius: 999px;
    pointer-events: all;
    appearance: none;
    z-index: 1;
    cursor: pointer;
  }
}

.slider {
  width: 100%;
}
</style>
